
// This file is generated by the maven plugin com.axley.js-remodel.  Do not edit!!!

import { GenSyncProject } from './GenSyncProject';
import { GenSyncTask } from './GenSyncTask';
import * as moment from 'moment';

export class GenTaskSyncManifest {

    exportedAt: moment.Moment;
    formatVersion: number;
    projects: GenSyncProject[];
    sourceSystem: string;
    tasks: GenSyncTask[];

    constructor();
    constructor( jsonObj: any );
    constructor( genTaskSyncManifest: GenTaskSyncManifest);

    constructor( input?: GenTaskSyncManifest ) {
        if ( input && typeof input !== 'number' ) {
            if ( input.exportedAt && typeof input.exportedAt === 'string' ) {
                this.exportedAt = moment(input.exportedAt).utc();
            } else {
                this.exportedAt = input.exportedAt;
            }
            this.formatVersion = input.formatVersion; // int [number]
            if ( input.projects && input.projects.map ) { // list [GenSyncProject]
                this.projects = input.projects.map( ( x: GenSyncProject ) => {
                    return new GenSyncProject( x );
                } );
            } else {
                this.projects = input.projects;
            }
            this.sourceSystem = input.sourceSystem; // string [string]
            if ( input.tasks && input.tasks.map ) { // list [GenSyncTask]
                this.tasks = input.tasks.map( ( x: GenSyncTask ) => {
                    return new GenSyncTask( x );
                } );
            } else {
                this.tasks = input.tasks;
            }
       }
    }

    static jsonResponseToList(arr: any[]): GenTaskSyncManifest[] {
        if (arr && arr.map) {
          return arr.map(a => new GenTaskSyncManifest(a));
        } else {
          return [];
        }
    }
}

